import { Component, OnInit, ViewChild, ElementRef, Renderer2, Input } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Parametric } from '../../cliente/parametric.model';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { MatChipInputEvent, MatAutocompleteSelectedEvent } from '@angular/material';
import { ApiService } from '../../core/api.service';

@Component({
  selector: 'app-chip-autocomplete',
  templateUrl: './chip-autocomplete.component.html',
  styleUrls: ['./chip-autocomplete.component.scss']
})
export class ChipAutocompleteComponent implements OnInit {
  @Input() modelo: Parametric;
  @Input() label: string;
  paisesList: Parametric[] = [];
  filteredOptions: Observable<Parametric[]>;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  separatorKeysCodes: number[] = [ENTER];
  myControl: FormControl = new FormControl();
  @ViewChild('clienteInput') clienteInput: ElementRef;
  private paisCtrl: FormControl;
  public focused = false;
  constructor(
    private renderer: Renderer2,
    private apiService: ApiService) {
  }

  ngOnInit() {
    this.getPaises();
  }

  async getPaises() {
    this.paisesList = await this.apiService.get(Parametric, Parametric.path + 'paises/', null).toPromise();
    this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(val => this.filterUsers(val))
        );
  }

  async getPaisesSinArg() {
    this.paisesList = await this.apiService.get(Parametric, Parametric.path + 'paises_sin_arg/', null).toPromise();
  }

  add(event: MatChipInputEvent): void {
    // debugger
    const input = event.input;
    const value = event.value;

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.myControl.setValue(null);
  }

  filterUsers(val: any): Parametric[] {
    if (val == null) {
      return this.paisesList;
    }
    return this.paisesList.filter(option =>
      option.description.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }

  remove(): void {
    this.modelo.id = undefined;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.modelo.description = event.option.value;
    for (const pais of this.paisesList) {
      if (pais.description === this.modelo.description) {
        this.modelo.id = pais.id;
        break;
      }
    }
    this.clienteInput.nativeElement.value = '';
    this.myControl.setValue(null);
    // this.renderer.invokeElementMethod(this.clienteInput.nativeElement, 'blur', []);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/chip-autocomplete/chip-autocomplete.component.ts